import { ClosedExceptionInput } from 'generated/graphql-types';
import { PromptOption } from '../../prompt-register/models/prompt-option.interface';
import { ScheduleOption } from '../../schedule-register/models/schedule-option-interface';

export interface AddClosedExceptionData {
   startDate: Date | null;
   startTime: string | null;
   endDate: Date | null;
   endTime: string | null;
   scheduleId: number | null;
   prompt: PromptOption | null;
   schedulesToCopyTo: ScheduleOption[] | null;
}

export interface AddClosedExceptionFormData {
   closedExceptionId: number | null;
   startDate: Date | null;
   startTime: Date | null;
   endDate: Date | null;
   endTime: Date | null;
   scheduleId: number | null;
   prompt: PromptOption | null;
   schedulesToCopyTo: ScheduleOption[] | null;
}

export interface ClosedExceptionItemView {
   closedExceptionId: number;
   startDate: Date | null;
   endDate: Date | null;
   startTime: Date | null;
   endTime: Date | null;
   prompt: PromptOption | null;
   isDeleted: boolean;
   schedulesToCopyTo: number[] | null;
}

export const closedExceptionFields: (keyof ClosedExceptionInput)[] = [
   'closedExceptionId',
   'startDate',
   'startTime',
   'endTime',
   'endDate',
   'scheduleId',
   'promptId',
];
